import { useEffect } from "react"
import { awaitFirebaseInitialization } from "../../config/firebase"
import { useLayout } from "../../hooks/useLayout"
import { TLayoutConsumerProps } from "./LayoutConsumer.types"
import { Navbar } from "../../features/Navbar"

export const LayoutConsumer: React.FC<TLayoutConsumerProps> = ({
  navigationMenu = false,
  children
}) => {
  useLayout(navigationMenu);

  useEffect(() => {
    (async () => await awaitFirebaseInitialization())();
  }, []);
  
  return (
    <div
      style={{
        backgroundColor: "#EDE7FD",
        height: "100vh",
        overflowY: "auto"
      }}
    >
      {navigationMenu && <Navbar />}
      {children}
    </div>
  );
};

